import { render, staticRenderFns } from "./VMultiselectWithApiSearch.vue?vue&type=template&id=b86f705a&"
import script from "./VMultiselectWithApiSearch.vue?vue&type=script&lang=js&"
export * from "./VMultiselectWithApiSearch.vue?vue&type=script&lang=js&"
import style0 from "./VMultiselectWithApiSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports